export const EmptyContent = () => {
  return (
    <div className="flex justify-center items-center h-full w-full bg-gradient-to-br from-slate-900 to-slate-700 text-white font-sans overflow-hidden relative">
      {/* Animated background elements */}
      <div className="absolute top-0 left-0 right-0 bottom-0 overflow-hidden opacity-30">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-gradient-radial from-sky-400/70 to-sky-400/0"
            style={{
              width: `${60 + Math.random() * 100}px`,
              height: `${60 + Math.random() * 100}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animation: `float ${8 + Math.random() * 12}s infinite ease-in-out`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <div className="p-14 rounded-3xl bg-slate-900/70 backdrop-blur-xl shadow-[0_25px_50px_-12px_rgba(0,0,0,0.5),0_0_0_1px_rgba(255,255,255,0.1)] text-center max-w-[650px] w-4/5 border border-white/10 animate-[floatSlow_6s_infinite_ease-in-out]">
        <div className="mb-2 text-sky-400 text-xl tracking-[0.2em] uppercase font-bold">Screen Ready</div>
        <div className="text-[2.5rem] font-bold mb-8">Waiting for Content</div>

        <div className="text-xl leading-relaxed opacity-80 mx-auto max-w-[90%]">
          This screen is ready to display your digital signage content.
          <br />
          Assign a playlist or channel to begin.
        </div>

        {/* Status indicator */}
        <div className="flex justify-center items-center mt-4">
          <div className="flex items-center gap-2 px-6 py-3 bg-sky-400/15 rounded-full text-sky-400 text-sm font-medium">
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 rounded-full bg-sky-400 animate-pulse" />
              Online and ready
            </div>
          </div>
        </div>
      </div>

      {/* Help text at bottom */}
      <div className="absolute bottom-6 left-0 w-full text-center text-sm opacity-50">
        Need help? Visit signagespace.com/academy
      </div>
    </div>
  )
}
